import styled from 'styled-components';

import { BodyM, BodyS } from 'atoms/typography';
import {
  Props as UseAmountWithConversionProps,
  useAmountWithConversion,
} from 'hooks/useAmountWithConversion';

const Line = styled.div<{ $column: boolean }>`
  display: flex;
  ${props =>
    props.$column
      ? `flex-direction: column;`
      : `align-items: baseline;
      gap: var(--half-unit);`};
`;

export type Props = UseAmountWithConversionProps & {
  column?: boolean;
  withApproxSymbol?: boolean;
  hideExponent?: boolean;
  actualMain?: string | null;
  actualExponent?: string | null;
};

export const AmountWithConversion = (props: Props) => {
  const {
    column = false,
    actualMain = undefined,
    withApproxSymbol = false,
    hideExponent,
    actualExponent = undefined,
    ...useAmountWithConversionProps
  } = props;
  const { main, exponent } = useAmountWithConversion(
    useAmountWithConversionProps
  );

  return (
    <Line $column={column}>
      {(actualMain || main) && (
        <BodyM bold as="p" color="var(--c-white)">
          {actualMain || main}
        </BodyM>
      )}
      {!hideExponent && (actualExponent || exponent) && (
        <BodyS as="span" color="var(--c-nd-600)">
          {withApproxSymbol && '≈ '}
          {actualExponent || exponent}
        </BodyS>
      )}
    </Line>
  );
};
